module.exports = __webpack_public_path__ + "img/pma560_large.d8337803.png";